import { render } from "./ScrollToTopButton.vue?vue&type=template&id=0d427c74&scoped=true"
const script = {}

import "./ScrollToTopButton.vue?vue&type=style&index=0&id=0d427c74&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d427c74"]])

export default __exports__